module.exports = __webpack_public_path__ + "static/media/earthSpecMap.d9cac8c8.jpeg";